import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DepartmentService } from '../services/department.service';

/**
 * WorkOrdersSettingsResolver
 */
@Injectable({ providedIn: 'root' })
export class DepartmentResolver implements Resolve<any> {
  /**
   * Constructor
   *
   * @param fuelTypeService FuelTypeService
   */
  constructor(private departmentService: DepartmentService) {}

  /**
   * Resolve
   *
   * @param route ActivatedRouteSnapshot
   * @param state RouterStateSnapshot
   */
  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.departmentService.list();
  }
}
